import { map, catchError, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { ServiceBase } from 'app/shared/serviceBase'
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { SharedService } from 'app/shared/services/shared.service';
import { User } from 'app/shared/models/User';
import { CompanyUserModel } from 'app/shared/models/company-user.model'
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as moment from 'moment';

@Injectable()
export class AccountService extends ServiceBase {
    private commonUrl: string = this.url + '/account/';
    user: User;

    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService,
        private sharedService: SharedService
    ) { super(); }

    initUser(): Observable<User> {
        return this._http
            .get<User>(this.commonUrl + 'getInfo')
            .pipe(map((user: User) => {
                // set user in shared service
                this.sharedService.changeCurrentUser(user);
                return user;
            }),
            catchError(this.handleError)
        )
    }

    initCompanyUser(): Observable<CompanyUserModel[]> {
        return this._http.get<CompanyUserModel[]>(this.commonUrl + 'getCompanyUser')
            .pipe(map((companyUserList => {
                this.sharedService.changeCurrentCompanyUser(companyUserList);
                return companyUserList;
            }),
            catchError(this.handleError)))
    }

	getUser(): Observable<User> {
		const completeUrl: string = this.commonUrl + 'getInfo';

		return this._http.get<User>(completeUrl).pipe(
			catchError(this.handleError));
	}

    getCompanyUser(): Observable<CompanyUserModel[]> {
        return this._http.get<CompanyUserModel[]>(this.commonUrl + 'getCompanyUser')
            .pipe(map((companyUserList => {
                this.sharedService.changeCurrentCompanyUser(companyUserList);
                return companyUserList;
            }),
                catchError(this.handleError)))
    }


	getUserByLocation(locationUserId: string): Observable<User> {
		return this._http.get<User>(this.commonUrl + 'GetUserInfoByLocation/' + locationUserId).pipe(
			catchError(this.handleError));
	}

	canAccess(objectId: string): Observable<boolean> {
		return this._http.get<boolean>(this.commonUrl + 'CanAccess/' + objectId).pipe(
			catchError(this.handleError));
	}

	getTableau(): Observable<string> {
		const completeUrl: string = this.commonUrl + 'getTableau';
		return this._http.get<string>(completeUrl).pipe(
			catchError(this.handleError));
	}
}
